import { create } from "zustand";
import { devtools } from "zustand/middleware";

export interface ServiceAddressOverride {
  street: string;
  address2?: string;
  city: string;
  state: string;
  zip: string;
}

interface ServiceAddressOverrideState {
  overrides: Record<string, ServiceAddressOverride>;
}

interface ServiceAddressOverrideActions {
  setOverride: (patientId: string, address: ServiceAddressOverride) => void;
  getOverride: (patientId: string) => ServiceAddressOverride | null;
  clearOverride: (patientId: string) => void;
  clearAllOverrides: () => void;
}

type ServiceAddressOverrideStore = ServiceAddressOverrideState & ServiceAddressOverrideActions;

export const useServiceAddressOverrideStore = create<ServiceAddressOverrideStore>()(
  devtools(
    (set, get) => ({
      overrides: {},

      setOverride: (patientId, address) => {
        set(
          (state) => ({
            overrides: { ...state.overrides, [patientId]: address },
          }),
          undefined,
          "serviceAddressOverride/setOverride",
        );
      },

      getOverride: (patientId) => get().overrides[patientId] ?? null,

      clearOverride: (patientId) => {
        set(
          (state) => {
            const overrides = { ...state.overrides };
            delete overrides[patientId];
            return { overrides };
          },
          undefined,
          "serviceAddressOverride/clearOverride",
        );
      },

      clearAllOverrides: () => {
        set({ overrides: {} }, undefined, "serviceAddressOverride/clearAllOverrides");
      },
    }),
    { name: "service-address-override-store" },
  ),
);
